import {css} from '@emotion/react';
import {Text, useBreakpointDown} from '@travel-frontend/core';
import {Link, Stack} from '@travel-frontend/ui-components';
import {useTranslation} from 'react-i18next';

import {Chevron} from '@/modules/common/components/Breadcrumbs/components/Chevron';

type Props = {
  children?: React.ReactNode;
};

export const Breadcrumbs = ({children, ...restProps}: Props) => {
  const smDown = useBreakpointDown('sm');
  const {t} = useTranslation('breadcrumb');

  return (
    <Stack direction="row" spacing="small" alignItems="baseline" {...restProps}>
      <Stack
        direction="row"
        spacing="none"
        alignItems="center"
        css={css`
          flex-wrap: wrap;
        `}
      >
        <Text
          hidden={smDown}
          preset="labelXSmall"
          css={css`
            padding-right: 4px;
          `}
        >
          {t('youAreHere')}
        </Text>
        <Text preset="labelXSmall">
          <Link href={import.meta.env.VITE_HOMEPAGE_URL}>{t('homepage')}</Link>
        </Text>
        <Chevron />
        {children}
      </Stack>
    </Stack>
  );
};
